(() => {
  const checkboxSelector = '[data-tsc-terms-checkbox]';
  const applyState = (checkbox) => {
    const form = checkbox.closest('form');
    if (!form) return;
    const accepted = checkbox.checked;
    form.dataset.tscTermsAccepted = String(accepted);
    form.querySelectorAll('[data-tsc-checkout], button[name="checkout"]').forEach((button) => {
      button.disabled = !accepted;
      button.setAttribute('aria-disabled', String(!accepted));
    });
    const error = form.querySelector('[data-tsc-terms-error]');
    if (error && accepted) error.hidden = true;
    const acceptedAt = form.querySelector('[data-tsc-terms-time]');
    if (acceptedAt) acceptedAt.value = accepted ? new Date().toISOString() : '';
  };
  const initialise = (scope = document) => {
    scope.querySelectorAll(checkboxSelector).forEach((checkbox) => {
      if (checkbox.dataset.tscTermsReady === 'true') return;
      checkbox.dataset.tscTermsReady = 'true';
      checkbox.checked = false;
      applyState(checkbox);
    });
  };
  document.addEventListener('change', (event) => {
    if (!event.target.matches(checkboxSelector)) return;
    applyState(event.target);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    const checkbox = form.querySelector(checkboxSelector);
    if (!checkbox || checkbox.checked) return;
    event.preventDefault();
    applyState(checkbox);
    const error = form.querySelector('[data-tsc-terms-error]');
    if (error) error.hidden = false;
    checkbox.focus();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches(checkboxSelector)) initialise(node.parentElement || node);
      else if (node.querySelector(checkboxSelector)) initialise(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
